import {
  CLOSE_PERIOD,
  DELIVERY_DAYS,
  HOLIDAYS_DATES,
  NEXT_DAY_DELIVERY_HOUR_LIMIT,
} from 'config/business.config';
import { toDate, differenceInDays } from 'utils/date';
import { SubscriptionFrequency } from 'lib/subscription/frequency';
import { toDateString, todayDate } from '../../utils/date';
import { format, isWithinInterval, startOfDay } from 'date-fns';

export interface DeliveryDatesOptions {
  date: string;
  description: string;
}

export const isHoliday = (date: Date) => {
  const dateStr = toDateString(date);

  return HOLIDAYS_DATES.find((x) => x === dateStr);
};
const canDeliveryNextDay = () => {
  const currentHour = todayDate().getHours();
  const currentMinutes = todayDate().getMinutes();

  if (
    currentHour > NEXT_DAY_DELIVERY_HOUR_LIMIT ||
    (currentHour >= NEXT_DAY_DELIVERY_HOUR_LIMIT && currentMinutes > 0)
  ) {
    return false;
  }

  return true;
};

export const isStoreClosed = () => {
  return isWithinInterval(new Date(), { start: CLOSE_PERIOD.closes, end: CLOSE_PERIOD.opens });
};

export const isStoreProcessing = () => {
  const period = {
    start: CLOSE_PERIOD.closes,
    end: CLOSE_PERIOD.processing,
  };

  const betweenNonProcessingDates = isWithinInterval(new Date(), period);

  return !betweenNonProcessingDates;
};

export const storeReopens = CLOSE_PERIOD.opens;

/**
 * The delivery date can't be in the same day if order is being placed after 9:00 AM
 * @param date
 */
export const canShipOnThisDate = (date: string | Date) => {
  const dateObj = date instanceof Date ? date : toDate(date);
  const today = todayDate();
  const dayNumber = dateObj.getDay();
  if (!DELIVERY_DAYS.find((c) => c === dayNumber)) {
    return false;
  }

  if (isHoliday(dateObj)) {
    return false;
  }

  const diff = differenceInDays(startOfDay(dateObj), startOfDay(today));
  //don't do delivery in the same day only in the next day
  if (diff <= 0) return false;
  //get the diference in days between two dates using date-fns

  if (diff === 1) return canDeliveryNextDay();

  return true;
};

/**
 * @todo if orders are being made after 9AM
 * @returns
 */
export const getDeliveryDates: () => Array<DeliveryDatesOptions> = () => {
  const dates: Array<DeliveryDatesOptions> = [];
  const today = todayDate();
  for (let i = 0; i < 60; i++) {
    const date = new Date(today.getTime() + i * 24 * 60 * 60 * 1000);
    const dateString = toDateString(date);

    if (canShipOnThisDate(date)) {
      const description = `${format(date, 'iiii - MMMM do')}`;
      dates.push({ date: dateString, description });
    }
  }
  return dates;
};

export const getSubscriptionFrequencyOptions: () => Array<string> = () => {
  return [SubscriptionFrequency.Weekly, SubscriptionFrequency.Fortnightly];
};
